import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import store from './store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {ajax} from '@/api';
import {vue3ScrollSeamless} from "vue3-scroll-seamless";
import 'dayjs/locale/zh-cn';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import {debounce} from "lodash";
import DataVVue3 from '@kjgl77/datav-vue3'

const resizeObserver = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends resizeObserver {
    constructor(callback) {
        callback = debounce(callback, 100);
        super(callback);
    }
};


const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus, {
    locale: zhCn,
});
app.use(router)

app.component(vue3ScrollSeamless)

app.use(store)  // vuex

app.use(DataVVue3)

app.mount('#app')